// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__RAf_T","modalFooterButton":"ModalNotes_modalFooterButton__1hU8F"};